module.exports = __webpack_public_path__ + "static/img/retail6.aba0f5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/retail6.png
// module id = AZQ5
// module chunks = 2